import { VALIDATE_EMAIL_DEBOUNCE } from '@mindfulchefuk/constants'
import {
  getFeature,
  LoqateFeatures,
} from '@mindfulchefuk/helpers/js/getFeature'
import asyncDebounce from '@mindfulchefuk/utils/asyncDebounce'
import EmailValidationInteractive from '@mindfulchefuk/services/loqate/EmailValidationInteractive/index'

import data from '@mindfulchefuk/services/loqate/EmailValidationInteractive/data/Validate'

export const Validate = async (
  Email: string,
  Timeout = 15000
): Promise<Record<string, unknown>> => {
  const { email: emailFeature }: LoqateFeatures = getFeature('loqate')

  if (emailFeature === 'dev') {
    return { data }
  }

  return EmailValidationInteractive().request({
    url: 'Validate/v2',
    params: { Email, Timeout },
  })
}

export default asyncDebounce(Validate, VALIDATE_EMAIL_DEBOUNCE)
